import { Box, Button, Card, Flex, Heading, Slot, Text, TextField } from "@radix-ui/themes";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { useFetch } from "../../hooks/useFetch";

import { useAppStore } from "../../stores/RootStore";
import { useEffect } from "react";
import { Link } from "react-router-dom";

type EnterInputs = {
  email: string
  password: string
}

export default function EnterView() {
  const store = useAppStore()
  const { control, handleSubmit, formState: { errors }} = useForm<EnterInputs>()
  const [{response}, doFetchLogin] = useFetch(`/users/sessions`, true)

  const onSubmit: SubmitHandler<EnterInputs> = (data) => {
    doFetchLogin({method: "POST", data: data})
  }

  useEffect(() => {
    if(!response) { return }
    localStorage.setItem('weld-jwt', JSON.stringify(response));
    store.setIsLogged(true)
  }, [response])

  return (
    <Flex height="100%" justify="center" align="center">
      <Card style={{ maxWidth: 420, minWidth: 420 }}>
        <Heading mb="4" mt="2" mx="2" weight="bold">
          Вход
        </Heading>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col gap-4 px-2"
        >
          <Controller
            control={control}
            name="email"
            rules={{ required: true }}
            render={({ field: { onChange, onBlur, value } }) => (
              <label>
                <Text as="div" size="1" mb="1" weight="medium">
                  Логин
                </Text>
                <TextField.Input
                  onChange={onChange}
                />
                {errors.email && <div role="alert" className="text-sm text-red-600">Введите логин</div>}
              </label>
            )}
          />
          <Controller
            control={control}
            name="password"
            rules={{ required: true }}
            render={({ field: { onChange, onBlur, value } }) => (
              <label>
                <Text as="div" size="1" mb="1" weight="medium">
                  Пароль
                </Text>
                <TextField.Input
                  type="password"
                  onChange={onChange}
                />
                {errors.password && <div role="alert" className="text-sm text-red-600">Введите пароль</div>}
              </label>
            )}
          />
          <Button my="4">Войти</Button>
        </form>
        <Flex justify="center">
          <Button size="2" variant="soft">
            <Link to='forget'>Забыл пароль</Link>
          </Button>
        </Flex>
      </Card>
    </Flex>
  )
}
